import {
  GET_USER_PROFILE,
  GET_USER_PROFILE_SUCCESS,
  GET_USER_PROFILE_FAILURE,
  EDIT_USER_PROFILE,
  EDIT_USER_PROFILE_CANCELLED,
  UPDATE_USER_PROFILE,
  UPDATE_USER_PROFILE_SUCCESS,
  UPDATE_USER_PROFILE_FAILURE,
  RESET_USER_PROFILE_STATE,
  SET_USER_PROFILE_CUSTOM_ATTRIBUTE,
  GET_BUSINESS_ATTRIBUTES,
  GET_BUSINESS_ATTRIBUTES_SUCCESS,
  GET_BUSINESS_ATTRIBUTES_FAILURE,
  UPDATE_BUSINESS_ATTRIBUTES,
  UPDATE_BUSINESS_ATTRIBUTES_SUCCESS,
  UPDATE_BUSINESS_ATTRIBUTES_FAILURE,
} from './actionTypes';

export const getUserProfile = accessToken => ({
  type: GET_USER_PROFILE,
  accessToken,
});

export const getUserProfileSuccess = (username, userAttributes) => ({
  type: GET_USER_PROFILE_SUCCESS,
  username,
  userAttributes,
});

export const getUserProfileFailure = () => ({
  type: GET_USER_PROFILE_FAILURE,
});

export const getBusinessAttributes = accessToken => ({
  type: GET_BUSINESS_ATTRIBUTES,
  accessToken,
});

export const getBusinessAttributesSuccess = businessAttributes => ({
  type: GET_BUSINESS_ATTRIBUTES_SUCCESS,
  businessAttributes,
});

export const getBusinessAttributesFailure = () => ({
  type: GET_BUSINESS_ATTRIBUTES_FAILURE,
});

export const editUserProfile = profileType => ({
  type: EDIT_USER_PROFILE,
  profileType,
});

export const editUserProfileCancelled = profileType => ({
  type: EDIT_USER_PROFILE_CANCELLED,
  profileType,
});

export const updateUserProfile = (
  accessToken,
  profileType,
  userAttributes,
  businessAttributes,
  previousValues,
) => ({
  type: UPDATE_USER_PROFILE,
  accessToken,
  profileType,
  userAttributes,
  businessAttributes,
  previousValues,
});

export const updateUserProfileSuccess = profileType => ({
  type: UPDATE_USER_PROFILE_SUCCESS,
  profileType,
});

export const updateUserProfileFailure = profileType => ({
  type: UPDATE_USER_PROFILE_FAILURE,
  profileType,
});

export const updateBusinessAttributes = (
  accessToken,
  profileType,
  businessAttributes,
  previousBuisnessAttributes,
  previousCleanedValues,
) => ({
  type: UPDATE_BUSINESS_ATTRIBUTES,
  accessToken,
  profileType,
  businessAttributes,
  previousBuisnessAttributes,
  previousCleanedValues,
});

export const updateBusinessAttributesSuccess = profileType => ({
  type: UPDATE_BUSINESS_ATTRIBUTES_SUCCESS,
  profileType,
});

export const updateBusinessAttributesFailure = profileType => ({
  type: UPDATE_BUSINESS_ATTRIBUTES_FAILURE,
  profileType,
});

export const resetUserProfileState = () => ({
  type: RESET_USER_PROFILE_STATE,
});

export const setUserProfileCustomAttribute = (key, value) => ({
  type: SET_USER_PROFILE_CUSTOM_ATTRIBUTE,
  key,
  value,
});
